/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Roles_Edit_Entity_ScopeInputs */

const en_forms_roles_edit_entity_scope = /** @type {(inputs: Forms_Roles_Edit_Entity_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity Scope`)
};

const de_forms_roles_edit_entity_scope = /** @type {(inputs: Forms_Roles_Edit_Entity_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geltungsbereich`)
};

/**
* | output |
* | --- |
* | "Entity Scope" |
*
* @param {Forms_Roles_Edit_Entity_ScopeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_roles_edit_entity_scope = /** @type {((inputs?: Forms_Roles_Edit_Entity_ScopeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Roles_Edit_Entity_ScopeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_roles_edit_entity_scope(inputs)
	return de_forms_roles_edit_entity_scope(inputs)
});